// Porte para JS de public.normalizar_texto / public.normalizar_telefone
// (supabase/migrations/20260902090000_extensoes_tipos_normalizacao.sql,
// mantido no historico do git). No Postgres essas eram colunas GENERATED,
// calculadas pelo banco em toda escrita; sem trigger de servidor, o front
// precisa computar e gravar os campos *_normalizado/a explicitamente antes
// de salvar um lead (ver lib/leads.ts).

/** Remove acentos via NFD + strip de diacriticos — equivalente pratico do
 * unaccent() do Postgres para texto em portugues. */
// Faixa Unicode dos sinais diacriticos combinantes (U+0300-U+036F) — escrita
// via \u explicito, nao como caractere bruto no arquivo, pra nao depender de
// como o editor/terminal renderiza um combining mark sozinho.
const DIACRITICOS = /[̀-ͯ]/g;

function semAcento(texto: string): string {
  return texto.normalize("NFD").replace(DIACRITICOS, "");
}

/** Chave normalizada de texto (lower + sem acento + espacos colapsados).
 * null quando vazio — para que a chave de dedup nunca case "vazio com vazio". */
export function normalizarTexto(texto: string | null | undefined): string | null {
  const normalizado = semAcento((texto ?? "").toLowerCase())
    .replace(/\s+/g, " ")
    .trim();
  return normalizado === "" ? null : normalizado;
}

/** Chave normalizada de telefone brasileiro: so digitos, sem +55. null
 * quando curto demais (< 8 digitos) para identificar alguem. */
export function normalizarTelefone(telefone: string | null | undefined): string | null {
  let digitos = (telefone ?? "").replace(/\D/g, "");

  if (digitos.length >= 12 && digitos.startsWith("55")) {
    digitos = digitos.slice(2);
  }

  return digitos.length < 8 ? null : digitos;
}
